<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="lb-header">
        <span class="material-symbols-rounded lb-trophy">emoji_events</span>
        <span class="lb-title">Leaderboard</span>
      </div>
      <ol class="lb-list">
        <li
          v-for="(p, i) in players"
          :key="p.name"
          class="lb-row"
          :class="{ '--first': i === 0 }"
          :style="{ '--row-i': i }"
        >
          <span class="lb-rank">{{ i + 1 }}</span>
          <span class="lb-avatar"></span>
          <span class="lb-bar lb-bar--name"></span>
          <span class="lb-score">{{ p.score }}</span>
        </li>
      </ol>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewLeaderboard',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  data() {
    return {
      players: [
        { name: 'Maya', score: 4280 },
        { name: 'Theo', score: 3950 },
        { name: 'Iris', score: 3720 },
        { name: 'Leo', score: 3410 },
        { name: 'Asha', score: 3180 },
      ],
    }
  },
})
</script>

<style scoped lang="scss">
.lb-bar {
  display: block; height: 6px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.12);
}
.lb-bar--name { width: 60%; }

.lb-header {
  display: flex; align-items: center; gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}
.lb-trophy {
  font-size: 18px; color: var(--accent);
}
.lb-title {
  font-size: 13px; font-weight: 800;
  color: rgba(15, 15, 20, 0.85);
}

.lb-list {
  list-style: none; margin: 0; padding: 0;
  display: grid; gap: 5px;
}
.lb-row {
  display: grid;
  grid-template-columns: 22px 22px 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.06);
  border-radius: 8px;
  opacity: 0;
  animation: lb-rise 4s ease-out infinite;
  animation-delay: calc(var(--row-i, 0) * 120ms + 400ms);
}
.lb-row.--first {
  background: color-mix(in srgb, var(--accent) 10%, white);
  border-color: color-mix(in srgb, var(--accent) 50%, transparent);
}
.lb-rank {
  font-size: 11px; font-weight: 800;
  color: rgba(15, 15, 20, 0.55);
  font-variant-numeric: tabular-nums;
}
.lb-row.--first .lb-rank { color: var(--accent); }
.lb-avatar {
  width: 22px; height: 22px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.08);
}
.lb-row.--first .lb-avatar {
  background: var(--accent);
}
.lb-score {
  font-size: 11px; font-weight: 800;
  color: rgba(15, 15, 20, 0.7);
  font-variant-numeric: tabular-nums;
}
.lb-row.--first .lb-score { color: var(--accent); }

@keyframes lb-rise {
  0%, 8%    { opacity: 0; transform: translateY(8px); }
  35%       { opacity: 1; transform: translateY(0); }
  92%, 100% { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .lb-row { animation: none; opacity: 1; transform: none; }
}
</style>
